import { ISurveyTemplate } from "../../../../types/resources";

export const getSurveyTemplateOptions = (templates: ISurveyTemplate[]) => (templates.map((template) => ({
  value: template.id,
  text: template.name,
}))).sort((a, b) => a.text.toLowerCase().localeCompare(b.text.toLowerCase()));
